/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Doc_Uploading_CountInputs */

const en_doc_uploading_count = /** @type {(inputs: Doc_Uploading_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uploading ${i?.count} documents…`)
};

const pt_br2_doc_uploading_count = /** @type {(inputs: Doc_Uploading_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enviando ${i?.count} documentos…`)
};

/**
* | output |
* | --- |
* | "Uploading {count} documents…" |
*
* @param {Doc_Uploading_CountInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_uploading_count = /** @type {((inputs: Doc_Uploading_CountInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Uploading_CountInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_uploading_count(inputs)
	return pt_br2_doc_uploading_count(inputs)
});